module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.drugController || _vm.drugController.hasError
    },
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_c('div', [_c('selectize', {
    staticClass: "form-control",
    attrs: {
      "load": _vm.loadResults,
      "labelField": "searchText",
      "valueField": "searchText",
      "searchField": "searchText",
      "maxOptions": "25",
      "openOnFocus": "true",
      "placeholder": "Search drug here"
    },
    model: {
      value: (_vm.selection),
      callback: function($$v) {
        _vm.selection = $$v
      },
      expression: "selection"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "selectize-spinner form-group",
    staticStyle: {
      "height": "100%",
      "z-index": "12"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.drugController || _vm.drugController.hasError) && !_vm.isLoading),
      expression: "(!drugController || drugController.hasError) && !isLoading"
    }],
    staticClass: "selectize-spinner form-group",
    staticStyle: {
      "height": "100%",
      "z-index": "11"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "35px",
      "padding-top": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    class: {
      'text-danger': !_vm.drugController || _vm.drugController.hasError
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "35px",
      "padding-top": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-1x fa-fw text-success"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58bf21f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58bf21f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/DrugSearchSelector/DrugSearchSelector.scp.html
// module id = 547
// module chunks = 0